<template>
  <layout-basic>
    <page-hero
      title="Partner Training"
      lead="Train partners and external stakeholders consistently."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="features" />
      </v-container>
    </section>

    <point-grid
      title="Consistent training beyond your payroll"
      :points="points"
      :columns="2"
      tint
    />

    <standard-cta
      title="Ready to train partners at scale?"
      lead="Watch the demo or experience IMPROVE and see how external learning works."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'SolutionPartnerTraining',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Partner Training | IMPROVE',
      description:
        'Train partners and external stakeholders consistently with one simple learning platform.',
      path: '/solutions/partner-training',
    });
  },
  data() {
    return {
      points: [
        'Deliver the same message to every partner',
        'Share your own products, processes and brand standards',
        'Track who has completed partner learning',
        'Scale training without extra admin',
        'Mobile-friendly access for busy partners',
        'Keep partner knowledge current as you grow',
      ],
    };
  },
};
</script>
